import { CurrencyDollarIcon, ChartBarIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { H2, H5, Body } from '../ui/Typography';

export default function RevenueDistribution() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
      <H2 className="text-primary mb-6 text-center">Revenue Distribution</H2>
      <div className="space-y-6">
        <div className="flex items-start space-x-4">
          <CurrencyDollarIcon className="w-6 h-6 text-secondary mt-1 shrink-0" />
          <div>
            <H5 className="text-gray-900 mb-1">100% Net Rental Income Distribution</H5>
            <Body className="text-gray-600">All net rental income from Real Estate assets distributed to RENT holders</Body>
          </div>
        </div>
        <div className="flex items-start space-x-4">
          <ChartBarIcon className="w-6 h-6 text-secondary mt-1 shrink-0" />
          <div>
            <H5 className="text-gray-900 mb-1">Distribution Formula</H5>
            <Body className="text-gray-600">(Individual RENT Holdings / Total Supply) × Net Rental Income</Body>
          </div>
        </div>
        <div className="flex items-start space-x-4">
          <UserGroupIcon className="w-6 h-6 text-secondary mt-1 shrink-0" />
          <div>
            <H5 className="text-gray-900 mb-1">Requirements</H5>
            <ul className="space-y-2">
              <li className="flex items-center">
                <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
                <Body className="text-gray-600">Minimum 1,000 RENT to qualify</Body>
              </li>
              <li className="flex items-center">
                <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
                <Body className="text-gray-600">15-day minimum holding period required for distributions</Body>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}